import CompanyService from "../../../services/CompanyService";

export const getDefaultActivityType = () =>
  CompanyService.getActivityTypes().find((x) => x.SMS && x.SMSDefault)
    ?.ActivityTypeID;
